import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedLanguage: null,
    energyMonitorDeDialog: false,
  },
  mutations: {
    setLanguage(state, payload) {
      state.selectedLanguage = payload;
    },
    setLangDe(state, payload) {
      state.energyMonitorDeDialog = payload;
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
    selectedLanguage: state => state.selectedLanguage,
    energyMonitorDeDialog: state => state.energyMonitorDeDialog,
  }
})
